"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EventManager = _interopRequireDefault(require("./EventManager"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultOptions = {
  type: _constants.TYPE.NOTICE,
  autoClose: true,
  closeButton: null,
  closeOnClick: null,
  updateId: null
};
var container = null;
var queue = [];
var toastId = 0;
/**
 * Merge provided options with the defaults settings and generate the toastId
 * @param {*} options
 */

function mergeOptions(options, type) {
  toastId += 1;
  return _objectSpread({}, defaultOptions, {}, options, {
    type: type,
    toastId: toastId
  });
}
/**
 * Dispatch toast. If the container is not mounted, the toast is enqueued
 * @param {*} content
 * @param {*} options
 */


function emitEvent(content, options) {
  if (container !== null) {
    _EventManager["default"].emit(_constants.ACTION.SHOW, content, options);
  } else {
    queue.push({
      action: _constants.ACTION.SHOW,
      content: content,
      options: options
    });
  }

  return options.toastId;
}

var toaster = Object.assign(function (content, options) {
  return emitEvent(content, mergeOptions(options, options && options.type || _constants.TYPE.NOTICE));
}, {
  alert: function alert(content, options) {
    return emitEvent(content, mergeOptions(options, _constants.TYPE.ALERT));
  },
  notice: function notice(content, options) {
    return emitEvent(content, mergeOptions(options, _constants.TYPE.NOTICE));
  },
  warning: function warning(content, options) {
    return emitEvent(content, mergeOptions(options, _constants.TYPE.WARNING));
  },
  info: function info(content, options) {
    return emitEvent(content, mergeOptions(options, _constants.TYPE.INFO));
  },
  dismiss: function dismiss() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return container && _EventManager["default"].emit(_constants.ACTION.CLEAR, id);
  },
  update: function update(id, options) {
    setTimeout(function () {
      if (container && typeof container.collection[id] !== 'undefined') {
        var _container$collection = container.collection[id],
            oldOptions = _container$collection.options,
            oldContent = _container$collection.content;
        var updateId = oldOptions.updateId !== null ? oldOptions.updateId + 1 : 1;

        var nextOptions = _objectSpread({}, oldOptions, {}, options, {
          toastId: id,
          updateId: updateId
        });

        var content = typeof nextOptions.render !== 'undefined' ? nextOptions.render : oldContent;
        delete nextOptions.render;
        emitEvent(content, nextOptions);
      }
    }, 0);
  }
});
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */

_EventManager["default"].on(_constants.ACTION.MOUNTED, function (containerInstance) {
  container = containerInstance;

  toaster.isActive = function (id) {
    return container.isToastActive(id);
  };

  queue.forEach(function (item) {
    _EventManager["default"].emit(item.action, item.content, item.options);
  });
  queue = [];
});

var _default = toaster;
exports["default"] = _default;